import { styled } from '@mui/material/styles';
import { css } from 'emotion';
import Text, { TEXT_COLOR, TEXT_SIZE } from '@components/Text';

export const placementTypes = {
  TOP: 'TOP',
  BOTTOM: 'BOTTOM',
  LEFT: 'LEFT',
  RIGHT: 'RIGHT',
} as const;

export type PlacementType = typeof placementTypes[keyof typeof placementTypes];

export const StyledText = styled(Text)({
  color: TEXT_COLOR.DARK_BLUE,
  fontSize: TEXT_SIZE.T5,
});

export const getPlacementClass = (placement: PlacementType, tiny?: boolean) => {
  const mainOffset = tiny ? '110%' : '160%';
  const crossOffset = tiny ? '20%' : '50%';
  switch (placement) {
    case placementTypes.TOP:
      return css({
        bottom: mainOffset,
        left: crossOffset,
        transform: `translateX(-${crossOffset})`,
        '&:after': {
          bottom: -6,
          left: 'calc(50% - 6px)',
          transform: 'rotate(-135deg)',
        },
      });
    case placementTypes.BOTTOM:
      return css({
        top: mainOffset,
        left: crossOffset,
        transform: `translateX(-${crossOffset})`,
        '&:after': {
          top: -6,
          left: 'calc(50% - 6px)',
          transform: 'rotate(45deg)',
        },
      });
    case placementTypes.LEFT:
      return css({
        right: mainOffset,
        top: crossOffset,
        transform: `translateY(-${crossOffset})`,
        '&:after': {
          right: -6,
          top: 'calc(50% - 6px)',
          transform: 'rotate(135deg)',
        },
      });
    case placementTypes.RIGHT:
    default:
      return css({
        left: mainOffset,
        top: crossOffset,
        transform: `translateY(-${crossOffset})`,
        '&:after': {
          left: -6,
          top: 'calc(50% - 6px)',
          transform: 'rotate(-45deg)',
        },
      });
  }
}; 